import { useAuthSelector } from 'app/data/auth';
import callflowQueryKeys from 'app/hooks/queries/callflow/callflowQueryKeys';
import { sdk } from 'app/sdk';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { MenuDoc } from 'types/menu';
import menuQueryKeys from 'app/hooks/queries/menu/menuQueryKeys';

export const useUpdateMenuPartial = () => {
  const authState = useAuthSelector();
  const queryClient = useQueryClient();
  return useMutation<any, AxiosError, MenuDoc, unknown>(
    (menuUpdatePartialDoc: MenuDoc) =>
      sdk.menu.mutate.updatePartial(
        menuUpdatePartialDoc,
        authState?.auth_token,
      ),
    {
      onSuccess: async resp => {
        // this always runs, even if the caller provides an onSuccess
        await queryClient.invalidateQueries(menuQueryKeys.all);
        await queryClient.invalidateQueries(callflowQueryKeys.all);
        // console.log('val:', val);
      },
    },
  );
};
